import FilterDropdown from 'components/Filter/FilterDropdown';
import Button from 'components/Form/Button';
import { Icon, Icons } from 'components/Icon';
import { Loader } from 'components/Loader';
import { format } from 'date-fns';
import React from 'react';
import { CSVLink } from 'react-csv';
import { printTable } from 'utils';

type Props = {
  showTab: boolean;
  searchQuery: string | number;
  handleSearch: (val: string) => void;
  handleTab?: (type: string) => void;
  exportData: any;
  exportHeader: any;
  fileName: string;
  isLoading?: boolean;
  activeTab?: string;
  showSpouseTab?: boolean;
  setShowAddModal?: (val: boolean) => void;
};

export default function TableProperties({
  showTab,
  searchQuery,
  handleSearch,
  handleTab,
  exportData,
  exportHeader,
  fileName,
  isLoading,
  activeTab,
  showSpouseTab = false,
  setShowAddModal
}: Readonly<Props>) {
  return (
    <div className="mt-6 grid grid-cols-3 gap-3">
      {showTab && handleTab && (
        <div className="col-span-3 col-start-1 flex flex-row items-center md:col-span-2">
          <button
            type="button"
            className={`rounded-tl text-xs font-bold ${
              activeTab === 'All'
                ? 'bg-white text-[#121638]'
                : 'bg-[#FF6606] text-white'
            } h-11 w-24 p-2`}
            onClick={() => handleTab('All')}
          >
            All
          </button>
          <button
            type="button"
            className={`rounded-t text-xs font-bold ${
              activeTab === 'Assigned'
                ? 'bg-white text-[#121638]'
                : 'bg-[#B4E2DE] text-[#00B388]'
            } h-11 w-24 p-2 transition ease-out`}
            onClick={() => handleTab('Assigned')}
          >
            Assigned
          </button>
          <button
            type="button"
            className={`rounded-t text-xs font-bold ${
              activeTab === 'Unassigned'
                ? 'bg-white text-[#121638]'
                : 'bg-[#F7B3B366] text-[#E82D2D]'
            } h-11 w-24 p-2 `}
            onClick={() => handleTab('Unassigned')}
          >
            Unassigned
          </button>
        </div>
      )}
      {showSpouseTab && handleTab && (
        <div className="col-span-3 col-start-1 flex flex-row items-center md:col-span-2">
          <button
            type="button"
            className={`rounded-tl text-xs font-bold ${
              activeTab === 'Spouse'
                ? 'bg-[#FF6606] text-white'
                : 'bg-white text-[#121638]'
            } h-11 w-24 p-2`}
            onClick={() => handleTab('Spouse')}
          >
            Spouse
          </button>
          <button
            type="button"
            className={`rounded-t text-xs font-bold ${
              activeTab === 'Children'
                ? 'bg-[#FF6606] text-white'
                : 'bg-white text-[#121638]'
            } h-11 w-24 p-2 transition ease-out`}
            onClick={() => handleTab('Children')}
          >
            Children
          </button>
        </div>
      )}

      <div className="col-span-3 flex flex-row items-center gap-2 md:col-span-1 md:col-start-7 md:col-end-7">
        <Button
          variant="outline"
          size="sm"
          label="Print"
          icon={<Icon name={Icons.Print} />}
          iconPosition="left"
          type="button"
          onClick={printTable}
          iconLabelSpacing={8}
          className="rounded-none border-none font-normal text-[#7F8B94]"
        />
        <CSVLink
          data={exportData}
          headers={exportHeader}
          filename={`${fileName}-report-${format(new Date(), 'dd-MMM-yyyy')}`}
          uFEFF={true}
        >
          <Button
            variant="outline"
            size="sm"
            label="Export"
            icon={<Icon name={Icons.Export} />}
            iconPosition="left"
            type="button"
            onClick={() => {}}
            iconLabelSpacing={8}
            className="rounded-none border-none font-normal text-[#7F8B94]"
          />
        </CSVLink>
        <div className="flex">
          {isLoading && <Loader type="Search" height={30} width={30} />}
          <div className="relative ">
            <input
              type="search"
              className="mr-[1.10rem] block h-[2.2rem] w-[20rem] rounded-none rounded-l border border-[#9F9F9F] bg-white text-sm text-gray-900 focus:border-none focus:ring-[#9F9F9F]"
              placeholder="Search"
              value={searchQuery}
              onChange={e => handleSearch(e.target.value)}
            />
            <div className="absolute right-0 top-0">
              <FilterDropdown
                iconPosition="right"
                icon={<Icon name={Icons.Filter} />}
                label="Filter"
                setSelectedOrder={val => console.log(val)}
                handleTableSearch={() => {}}
              />
            </div>
          </div>
          {showSpouseTab && (
            <div className="col-span-1 col-start-7 col-end-7 ms-3">
              {activeTab === 'Spouse' ? (
                <Button
                  variant="primary"
                  size="custom"
                  className="place-self-end rounded-sm border-[#FF7A00] p-2 text-center text-xs font-medium text-[#FF7A00] disabled:border disabled:border-[#D7D7D7] disabled:bg-[#FFFFFF] disabled:text-[#D7D7D7]"
                  label="Add Spouse"
                  iconPosition="left"
                  icon={
                    <Icon
                      name={Icons.Add}
                      fill="#FFFFFF"
                      width={15}
                      height={15}
                    />
                  }
                  onClick={() => setShowAddModal?.(true)}
                ></Button>
              ) : (
                <Button
                  variant="primary"
                  size="custom"
                  className="place-self-end rounded-sm border-[#FF7A00] p-2 text-center text-xs font-medium text-[#FF7A00] disabled:border disabled:border-[#D7D7D7] disabled:bg-[#FFFFFF] disabled:text-[#D7D7D7]"
                  label="Add Child"
                  iconPosition="left"
                  icon={
                    <Icon
                      name={Icons.Add}
                      fill="#FFFFFF"
                      width={15}
                      height={15}
                    />
                  }
                  onClick={() => setShowAddModal?.(true)}
                ></Button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
